// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"c3afba50","977":"91d9b2e1"}[chunkId] + ".chunk.js";
};